// extracted by mini-css-extract-plugin
export default {"Menu":"bgo_a bhc_h","Menu__offsetParent":"bgo_b bhc_bj","Menu__trigger--shadowed":"bgo_c"};